export const iconFontAwesomeDisasterCrisisPersonWalkingArrowRight = (
	<i className="fa-solid fa-person-walking-arrow-right"></i>
);
